import shoe1 from './Images/shoe1.png'
import shoe2 from './Images/shoe2.png'
import shoe3 from './Images/shoe3.png'
import shoe4 from './Images/shoe4.png'
import shoe5 from './Images/shoe5.png'
import shoe6 from './Images/shoe6.png'
import shoe7 from './Images/shoe7.png'
import shoe8 from './Images/shoe8.png'
import shoe9 from './Images/shoe9.png'
import shoe10 from './Images/shoe10.png'
import shoe11 from './Images/shoe11.png'
import shoe12 from './Images/shoe12.png'
import shoe13 from './Images/shoe13.png'
import shoe14 from './Images/shoe14.png'
import shoe15 from './Images/shoe15.png'
import shoe16 from './Images/shoe16.png'
import shoe17 from './Images/shoe17.png'
import shoe18 from './Images/shoe18.png'
import shoe19 from './Images/shoe19.png'
import shoe20 from './Images/shoe20.png'
import shoe21 from './Images/shoe21.png'

const ShoeDet = [
    {
        id: 1,
        name: "Sports Running Shoes for Men's & Boy's",
        brand: "BRUTON ",
        price: 499,
        image: shoe1,
        style: "Sneaker"
    },
    {
        id: 2,
        name: "Men's Sports Shoes with Lightweight Phylon Sole for Men's & Boy's",
        brand: "ASIAN",
        price: 1316,
        image: shoe2,
        style: "Sneaker"
    },
    {
        id: 3,
        name: "Casual Sneaker Shoes PARADISE-01 Sneakers for Women",
        brand: "ASIAN",
        price: 580,
        image: shoe3,
        style: "Sneaker"
    },
    {
        id: 4,
        name: "Campus Women's Zoe Plus Walking Shoe",
        brand: "Campus",
        price: 727,
        image: shoe4,
        style: "Running Shoe"
    },
    {
        id: 5,
        name: "Vendoz Women & Girls White Casual Sports Shoes Sneakers - 36 EU",
        brand: "Vendoz",
        price: 588,
        image: shoe5,
        style: "Sneaker"
    },
    {
        id: 6,
        name: "Puma Women's Cilia Wedge Sneaker",
        brand: "Puma",
        price: 4179,
        image: shoe6,
        style: "Sneaker"
    },
    {
        id: 7,
        name: "Campus Mens Oxyfit (N) Walking Shoes",
        brand: "Campus",
        price: 729,
        image: shoe7,
        style: "Sneaker"
    },
    {
        id: 8,
        name: "Boss-Grip Black Derby Shoes for Men",
        brand: "Bata",
        price: 659,
        image: shoe8,
        style: "Derby"
    },
    {
        id: 9,
        name: "Lancer Men's Sports Running Shoes Indus-251",
        brand: "Lancer",
        price: 554,
        image: shoe9,
        style: "Running"
    },
    {
        id: 10,
        name: "Reebok Mens Stride RunnerRunning Shoe",
        brand: "Reebok",
        price: 1349,
        image: shoe10,
        style: "Running"
    },
    {
        id: 11,
        name: "YOHO Chonks Women’s Sporty Comfortable Chunky Sneakers",
        brand: "YOHO",
        price: 1799,
        image: shoe11,
        style: "Sneaker"
    },
    {
        id: 12,
        name: "FAUSTO Women's Stylish Hook & Loop Sneakers ",
        brand: "FAUSTO",
        price: 942,
        image: shoe12,
        style: "Sneaker"
    },
    {
        id: 13,
        name: "SPARX Women's Mesh Walking Shoe",
        brand: "SPARX",
        price: 826,
        image: shoe13,
        style: "Athletic"
    },
    {
        id: 14,
        name: "Campus Women's Raye Running Shoe",
        brand: "Campus",
        price: 949,
        image: shoe14,
        style: "Mid-Top"
    },
    {
        id: 15,
        name: "Mens Comfortable Lightweight Outdoor Lace Up Classy Casual Sport Shoes",
        brand: "AADI",
        price: 669,
        image: shoe15,
        style: "Running Shoes"
    },
    {
        id: 16,
        name: "Men NITROEDGE-01 Running and Gym wear Running Shoes with Laces",
        brand: "ASIAN",
        price: 1229,
        image: shoe16,
        style: "Sneaker"
    },
    {
        id: 17,
        name: "Bata Mens Slipon Walking Shoes Trek Grey",
        brand: "Bata",
        price: 556,
        image: shoe17,
        style: "Sneaker"
    },
    {
        id: 18,
        name: "Campus Men's First Running Shoe",
        brand: "Campus",
        price: 999,
        image: shoe18,
        style: "Running Shoe"
    },
    {
        id: 19,
        name: "Puma Women's Pop Sneaker",
        brand: "Puma",
        price: 1845,
        image: shoe19,
        style: "Sneaker"
    },
    {
        id: 20,
        name: "Casual Shoes Colorblock Sneakers with Ultra Soft Cushion Lace-Up Shoes",
        brand: "Centrino",
        price: 799,
        image: shoe20,
        style: "Sneaker"
    },
    {
        id: 21,
        name: "Vendoz Women White Stylish Casual Sneakers",
        brand: "Vendoz",
        price: 557,
        image: shoe21,
        style: "Sneaker"
    },
]
export default ShoeDet